import React, { useState } from "react";

import { SelectDashboardList } from "./SelectDashboardList";
import { graphql, useMutation } from "react-relay";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";

import { Box } from "arkh";
import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";

type StorecastDeviceAdminProps =
  StoreAdminNavigationScreenProps<"ScreenAdminSelectDashboard">;

export const StorecastScreenAdminSelectDashboard = ({
  route: { params },
  navigation,
}: StorecastDeviceAdminProps) => {
  const [dashboardId, setDashboardId] = useState(params.currentDashboardId);

  const [setDashboard, loading] = useMutation(graphql`
    mutation StorecastScreenAdminSelectDashboardMutation(
      $screenId: ID!
      $dashboardId: ID!
    ) {
      storecast {
        setScreenDashboard(screenId: $screenId, dashboardId: $dashboardId) {
          id
          name
          dashboard {
            id
            name
          }
        }
      }
    }
  `);

  useNavigationHeader({
    type: "SAVE",
    onCancel() {
      navigation.goBack();
    },
    disabled: dashboardId === params.currentDashboardId,
    saveLoading: loading,
    onSave() {
      setDashboard({
        variables: { screenId: params.screenId, dashboardId },
        onCompleted: navigation.goBack,
      });
    },
  });

  return (
    <Box style={{ flex: 1 }} spaceVertical="medium" spaceHorizontal="medium">
      <SelectDashboardList
        dashboardId={dashboardId}
        setDashboardId={setDashboardId}
        addDashboard={() =>
          navigation.navigateDeprecated("StorecastCreate", {
            assignScreenId: params.screenId,
          })
        }
      />
    </Box>
  );
};
